<template>
 <main>
  <p>If you are looking to contact me about one of my projects, please use the links provided on each project.</p>
  <ul class="button-block-list list">
			<li>
    <a class="emailLink background-fade-green" href="mailto:mikelargent@mail.com?Subject=SimpleMike.com" title="My Email">
     <img src="/lib/icon-email.svg">
     <span class="text">email</span>
    </a>
   </li>
   <li>
    <a class="githubLink background-fade-green" href="https://github.com/michaellargent" title="My Github" target="_blank">
     <img src="/lib/icon-github.svg">
     <span class="text">github</span>
    </a>
   </li>
   <li>
    <a class="twitterLink background-fade-green" href="https://codepen.io/michaellargent/" title="My CodePen" target="_blank">
     <img src="/lib/icon-codepen.svg">
     <span class="text">codepen</span>
    </a>
   </li>
   <li>
    <a class="twitterLink background-fade-green" href="https://twitter.com/michaellargent" title="My Twitter" target="_blank">
     <img src="/lib/icon-twitter.svg">
     <span class="text">twitter</span>
    </a>
   </li>
   <li>
    <a class="linkedinLink background-fade-green" href="https://www.linkedin.com/in/michael-largent-11053534/" title="My LinkedIn" target="_blank">
     <img src="/lib/icon-linkedin.svg">
     <span class="text">linkedin</span>
    </a>
   </li>
  </ul>
 </main>
</template>
<script>
import updateAvatarTitle from '@/lib/updateAvatarTitle';
export default {
 mounted(){
  updateAvatarTitle('Contact',this);
 }
}
</script>
<style lang="scss" scoped>
@import '@/lib/button-block-list.scss';
.list{
 justify-content: space-between;
}
address a{
 display: block;
 color:#fff;
 text-decoration:none;
 font-size:0.9rem;
 margin:10px auto;
 font-style:normal;
 padding:10px 0;
 max-width:300px;
 img{
  display:block;
  margin:0 auto;
 }
}
</style>
